import { gql } from '@apollo/client'

export const getMoveOutQuery = gql`
  query GetMoveOutByLeaseId($leaseId: String!) {
    moveOut(leaseId: $leaseId) {
      move_out_id
      move_out_status_id
      move_out_reason_id
      ntv_date
      forwarding_address_id
      move_out_date
      person_array {
        person_id
        active
        agent_id
        ntv_date
      }
    }
  }
`

export const getMoveOutReasonsQuery = gql`
  query GetMoveOutReasons {
    moveOutReasons {
      move_out_reason_id
      move_out_reason_name
    }
  }
`

export const getMoveOutStatusesQuery = gql`
  query GetMoveOutStatuses {
    moveOutStatuses {
      move_out_status_id
      move_out_status_name
    }
  }
`
